import * as types from './types';

export const Delivery = (formURL) => ({
    type: types.FORM_URL,
    formURL
});